import _jsx from "@babel/runtime/helpers/jsx";
import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import _get from 'lodash/get';
import { withKeyboardAccessibility } from '../Utilities/AccessibilityUtilities.js';
import Badge from '../Badge/index.js';
import Image from '../Image/index.js';
import Panel from '../Panel/index.js';
function ContentPreview(_ref) {
  let {
    badge,
    category,
    headline,
    summary,
    image,
    imageProps,
    orientation = 'landscape',
    className,
    withPanel = false,
    onClick,
    mediaClassName,
    contentClassName,
    uiContext,
    mediaPosition = 'left',
    cta,
    contentMinHeight,
    ...rest
  } = _ref;
  let mediaImage = image;
  if (image && typeof image !== 'object' || _get(imageProps, 'src')) {
    mediaImage = /*#__PURE__*/React.createElement(Image, Object.assign({
      className: "media-gallery-viewer",
      src: image,
      alt: headline
    }, imageProps));
  }
  const Component = withPanel ? Panel : 'div';
  const rootClassName = clsx({
    'content-preview': true,
    'display-flex align-items-stretch': !!mediaImage,
    'padding-3': withPanel,
    'padding-4': withPanel && cta,
    'cursor-pointer': onClick,
    'flex-column': orientation === 'portrait' || uiContext === 'snapshot',
    'justify-content-end': mediaPosition === 'right'
  }, className);
  const contentWrapperClassName = clsx({
    'display-flex flex-column justify-content-start': true,
    // add a little spacing between media and content
    'margin-left-4': !!mediaImage && orientation === 'landscape' && mediaPosition === 'left',
    'margin-right-4': !!mediaImage && orientation === 'landscape' && mediaPosition === 'right'
  }, contentClassName);
  const wrapperProps = {
    'data-cmp': 'contentPreview',
    className: rootClassName,
    ...rest
  };
  if (onClick) {
    wrapperProps.onClick = onClick;
    wrapperProps.tabIndex = 0;
    if (withKeyboardAccessibility) {
      wrapperProps.onKeyDown = withKeyboardAccessibility(onClick);
    }
  }
  return /*#__PURE__*/React.createElement(Component, wrapperProps, mediaImage && mediaPosition === 'left' && /*#__PURE__*/_jsx("div", {
    className: clsx('content-preview-media', mediaClassName),
    style: {
      ...(imageProps?.width && {
        width: imageProps?.width
      })
    }
  }, void 0, mediaImage), (category || headline || summary) && /*#__PURE__*/_jsx("div", {
    className: contentWrapperClassName,
    style: contentMinHeight ? {
      height: contentMinHeight
    } : undefined
  }, void 0, category && /*#__PURE__*/_jsx("div", {
    className: "content-preview-category"
  }, void 0, category), headline && /*#__PURE__*/_jsx("div", {
    className: "content-preview-headline"
  }, void 0, headline), summary && /*#__PURE__*/_jsx("div", {
    className: "content-preview-summary"
  }, void 0, summary), cta && /*#__PURE__*/_jsx("div", {
    className: "content-preview-cta margin-top-2"
  }, void 0, cta)), mediaImage && mediaPosition === 'right' && /*#__PURE__*/_jsx("div", {}, void 0, mediaImage), badge && /*#__PURE__*/_jsx(Badge, {
    className: "content-preview-badge"
  }, void 0, badge));
}
export default ContentPreview;